"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractSyntaxTree_1 = require("./AbstractSyntaxTree");
exports.AbstractSyntaxTree = AbstractSyntaxTree_1.AbstractSyntaxTree;
var operatorPrecedence_1 = require("../util/operator/operatorPrecedence");
var statement = /** @class */ (function () {
    function statement() {
    }
    statement.is = function (code, index) {
        return code.slice(index, index + 8) === 'function' && /[^_$A-Za-z0-9]/.test(code[index + 9]);
    };
    return statement;
}());
function compile(code, startIndex, context) {
    var result = {
        root: null,
        context: context,
        cache: {
            type: "",
            value: ""
        }
    };
    return start(code, startIndex, result);
}
exports.compile = compile;
function start(code, index, result) {
    while (true) {
        var cur = code[index];
        if (/\s/.test(cur)) {
            index++;
            continue;
        }
        if (statement.is(code, index)) {
            //声明
            continue;
        }
        var oLength = operatorPrecedence_1.operatorPrecedence.getLength(code, index);
        if (oLength > 0) {
            index = doOperator(code, index, result, oLength);
        }
        else if ("0123456789".indexOf(cur) > -1) {
            index = doNumber(code, index, result);
        }
        else if (cur === "\"" || cur === "'") {
            index = doString(code, index, result);
        }
        else if (/[a-zA-Z_$]/.test(cur)) {
            index = doVariable(code, index, result);
        }
        else {
            throw new Error(cur + "不认识，index:" + index);
        }
        if (!code[index]) {
            if (!result.root) {
                result.root = new AbstractSyntaxTree_1.AbstractSyntaxTree(",");
            }
            if (result.cache) {
                var abstractSyntaxTree = new AbstractSyntaxTree_1.AbstractSyntaxTree("");
                abstractSyntaxTree.value = result.cache.value;
                abstractSyntaxTree.type = result.cache.type;
                result.root.setRight(abstractSyntaxTree);
            }
            while (result.root.parent) {
                result.root = result.root.parent;
            }
            break;
        }
    }
    return result;
}
function doNumber(code, index, result) {
    result.cache.type = "number";
    result.cache.value = code[index];
    index++;
    while (true) {
        if (code[index] && "0123456789.".indexOf(code[index]) > -1) {
            result.cache.value += code[index];
            index++;
        }
        else {
            break;
        }
    }
    return index;
}
function doString(code, index, result) {
    result.cache.type = "string";
    index++;
    result.cache.value = code[index];
    index++;
    while (true) {
        if (!code[index]) {
            throw new Error("结尾引号没有找到！");
        }
        if (code[index] !== "\"" && code[index] !== "'") {
            result.cache.value += code[index];
            index++;
        }
        else {
            index++;
            break;
        }
    }
    return index;
}
function doVariable(code, index, result) {
    result.cache.type = "variable";
    result.cache.value = code[index];
    index++;
    while (true) {
        if (code[index] && /[a-zA-Z$_]/.test(code[index])) {
            result.cache.value += code[index];
            index++;
        }
        else {
            break;
        }
    }
    return index;
}
function doOperator(code, index, result, oLen) {
    var operator = new AbstractSyntaxTree_1.AbstractSyntaxTree(code.slice(index, oLen + index));
    var abstractSyntaxTree = new AbstractSyntaxTree_1.AbstractSyntaxTree("");
    abstractSyntaxTree.value = result.cache.value;
    abstractSyntaxTree.type = result.cache.type;
    if (result.root) {
        if (operatorPrecedence_1.operatorPrecedence.isHighPrecedence(operator.operator.sign, result.root.operator.sign)) {
            operator.setLeft(abstractSyntaxTree);
            result.root.setRight(operator);
            operator.setParent(result.root);
        }
        else {
            result.root.setRight(abstractSyntaxTree);
            var parent_1 = result.root.parent;
            var child = result.root;
            if (parent_1) {
                while (true) {
                    if (!parent_1) {
                        operator.setLeft(child);
                        break;
                    }
                    if (operatorPrecedence_1.operatorPrecedence.isHighPrecedence(operator.operator.sign, parent_1.operator.sign)) {
                        operator.setLeft(child);
                        parent_1.setRight(operator);
                        operator.setParent(parent_1);
                        break;
                    }
                    else {
                        child = parent_1;
                        parent_1 = parent_1.parent;
                    }
                }
            }
            else {
                operator.setLeft(result.root);
            }
        }
    }
    else {
        operator.setLeft(abstractSyntaxTree);
    }
    result.root = operator;
    result.cache = { type: "", value: "" };
    index += oLen;
    return index;
}
